import { CustomDesignState } from '#/src/shared/store/redux/custom-design/types';

export const CustomDesignInitialState: CustomDesignState = {
    title: '',
    subtitle: '',
    authorizationUrl: '',
    backUrl: '',
    client: '',
};
